export default {"src":"/_next/static/media/ring.8513f928.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};